"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Sat Nov 03 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var GridSettingsConverter_1 = require("./conversions/GridSettingsConverter");

var GridSettingsConverterImpl_1 = require("./conversions/GridSettingsConverterImpl");
/**
 * GeneralConfigurationsAppModule
 *
 * @author RV
 */


var GridSettingsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(GridSettingsAppModule, _AppModule_1$AppModul);

  function GridSettingsAppModule() {
    var _this;

    _classCallCheck(this, GridSettingsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'gridSettingsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(GridSettingsAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(GridSettingsConverter_1.GridSettingsConverter).to(GridSettingsConverterImpl_1.GridSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return GridSettingsAppModule;
}(AppModule_1.AppModule);

exports.GridSettingsAppModule = GridSettingsAppModule;